// extracted by mini-css-extract-plugin
export default {"AuthFeed":"AuthFeed_AuthFeed__7wxBB","feed__wrapper":"AuthFeed_feed__wrapper__mFGal","feed__list":"AuthFeed_feed__list__jxDKy"};